require('./nav.less');

var Backbone = require('backbone'),
    $ = require('jquery'),
    fvChannel = require('glRadio').channel('FV');

module.exports = Marionette.ItemView.extend({
    constructor: function(options) { /* serialize data called b/f init */
        this.vCh = options.vChannel;
        Marionette.ItemView.prototype.constructor.call(this, options);
    },
    template: require('./nav.hbs'),
    serializeData: function() {

        var activeDocument = this.vCh.request('activeDocument'),
            pages = activeDocument.pageCollection,
            docHasNoPages = activeDocument.get('docHasNoPages'); //prob more efficient to handle doc has no pages with css on class

        return {
            numPages: pages.length,
            disableNavInput: pages.length < 2,
            curPgNumber: pages.length > 0 ? this.vCh.request('currentPageNumber') : 0,
            disableFirstOrPrevPg: this.vCh.request('isFirstPage') || docHasNoPages,
            disableLastOrNextPg: this.vCh.request('isLastPage') || docHasNoPages
        };

    },
    ui: {
        nextBtn:    '.next-page',
        prevBtn:    '.prev-page',
        firstPg:    '.first-page',
        lastPg:     '.last-page',
        pageInput:  '#activePage',
        totalPages: '#totalPages'
    },
    events: function() {

        var vCh = this.vCh;

        return {
            'click @ui.nextBtn':        _.bind(vCh.command, vCh, 'goNextPage'),
            'click @ui.prevBtn':        _.bind(vCh.command, vCh, 'goPrevPage'),
            'click @ui.firstPg':        _.bind(vCh.command, vCh, 'goToFirstPage'),
            'click @ui.lastPg':         _.bind(vCh.command, vCh, 'goToLastPage'),
            'click @ui.pageInput':      'setPageInputFocus',
            'change @ui.pageInput':     'validatePgInputAndGoToPage',
            'keyup @ui.pageInput':      'triggerChangeIE'
        };

    },
    updatePostPageChange: function(opts) {
        this.ui.pageInput.val(opts.page.get('number'));
        this.ui.prevBtn
            .add(this.ui.firstPg)
            .toggleClass('disabled', opts.isFirstPg );
        this.ui.nextBtn
            .add(this.ui.lastPg)
            .toggleClass('disabled', opts.isLastPg);
    },
    updateTotalPages: function(numPages) {
        this.ui.totalPages.text(numPages);
    },
    setPageInputFocus: function(e) {
        $(e.currentTarget).select();
    },
    validatePgInputAndGoToPage: function(e) {

        var pg = $(e.currentTarget).val(),
            pgNum = parseInt(pg);

        if ( isNaN(pgNum) )  {
            this.undelegateEvents();
            this.ui.pageInput.val( this.vCh.request('currentPageNumber') );

            this.vCh.trigger('alert:show', {
                type: 'error',
                shortMessage: 'Please enter a valid page number.',
                closeTimeout: 3000
            });

            this.delegateEvents();
            this.setPageInputFocus(e);
            return;   //prevent page change from bubbling with bad number (IE)
        }

        if (pgNum < 1 || pgNum > this.vCh.request('activeDocPages').length) {
            this.undelegateEvents();
            this.ui.pageInput.val( this.vCh.request('currentPageNumber') );
            this.setPageInputFocus(e);
            
            this.vCh.trigger('alert:show', {
                type: 'error',
                shortMessage: 'Please enter a page number between 1 and ' + this.vCh.request('activeDocPages').length + '.',
                closeTimeout: 3000
            });

            this.setPageInputFocus(e);
            this.delegateEvents();
            return false; //don't attempt to move
        } else {

            this.vCh.command('goToPage', this.vCh.request('activeDocPages').at(pgNum - 1) );
            if (fvChannel.request('settings').isIE) { $(e.currentTarget).trigger('blur'); } //unfocus the field for IE }

        }
    },
    triggerChangeIE: function(e) {
        if (fvChannel.request('settings').isIE && e.keyCode==13) {
            $(e.currentTarget).trigger('change'); //force IE to recognize an input change on enter key
        }
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/layout/header/headerCenter/nav/nav.js
 ** module id = 714
 ** module chunks = 0
 **/